// src/App.js
import React from 'react';
import './App.css';
import FormComponent from './FormComponent';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Submit Your Name and Class</h1>
        <FormComponent />
      </header>
    </div>
  );
}

export default App;
